module.exports = __webpack_public_path__ + "static/media/subChild.95272138.svg";